import { useMemo } from 'react';
import {
  EmailConfig,
  WidgetBase,
  WidgetTypes,
} from '@mm/state/model/WidgetModel';
import { useSupportedWidgets } from '../../../../../../../../../common/components/AddWidgetInsert/AddWidgetInsert';
import { useSelector } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';

const byContent = [
  WidgetTypes.TEXT,
  WidgetTypes.QUICK_QUESTION,
  WidgetTypes.QQ_OPTIONS,
  WidgetTypes.QQ_EMAIL,
  WidgetTypes.QQ_PHONE,
  WidgetTypes.QQ_INFO,
  WidgetTypes.EMAIL,
];

export const useDialoguePreviewMessage = ({
  dialogueId,
  widgetId,
}: {
  dialogueId?: number;
  widgetId?: number;
}) => {
  const supportedWidgets = useSupportedWidgets();
  const widgets = useSelector(
    (state: StoreState) => state.widget.entities,
  ).filter(w => (widgetId ? w.id === widgetId : w.pageId === dialogueId));

  const widget = widgets[0];

  const {
    config: { subject, previewText } = { subject: null, previewText: null },
  } = (widget as unknown as WidgetBase<EmailConfig>) || {};

  return useMemo(() => {
    const type = widget?.type;

    if (!byContent.includes(type)) {
      return supportedWidgets.allWidgets.find(w => w.type === type)?.name || '';
    }

    if (type === WidgetTypes.EMAIL) {
      return subject || previewText || '';
    }

    return widget.config?.body || widget.config?.title || '';
  }, [
    widget?.id,
    widget?.config?.body,
    widget?.config?.title,
    subject,
    previewText,
  ]);
};
